define([
        'jQuery',
        'library/fcse-compatibility/object',
        'library/fcse-component/optionsMixin',
        'library/fcse-events/eventDispatcher',
        'simplemodal'
    ],
    function ($, Object, OptionsMixin, EventDispatcher) {
        /**
         * @param selector jQuery selector for the targeted elements
         * @param options
         * @constructor
         */
        let GiataVideoModal = function (selector, options) {
            EventDispatcher.apply(this, arguments);

            // Set default options
            let defaultOptions = {
                modalTriggerSelector: '[data-fcse-role="giata-video-modal-trigger"]',
                modalSelector: '[data-fcse-role="giata-video-modal"]',
                modalPlayerContainerSelector: '[data-fcse-role="giata-video-modal-player-container"]',

                playerClass: 'giatavideomodal--player'
            };
            this.addOptions(defaultOptions, options);

            // Assign elements
            this.elements = $(selector);

            // Initialize component
            this._init();
        };

        GiataVideoModal.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
            /**
             * Initializes the components
             * @private
             */
            _init: function () {
                let self = this;

                // Iterate of youtube elements
                this.elements.each(function (idx, element) {
                    let trigger = $(self.option('modalTriggerSelector'), element);
                    let modal = $(self.option('modalSelector'), element);

                    // Store instance of modal in trigger
                    trigger.data('giatavideomodal', modal);

                    // Attach click handler
                    trigger.click($.proxy(self._onTriggerClick, self));
                });
            },

            /**
             * Trigger click handler
             * @param event
             * @private
             */
            _onTriggerClick: function (event) {
                // Open modal
                let modalNode = $(event.currentTarget).data('giatavideomodal');
                modalNode.modal();

                // Create video Player
                this._createVideoPlayer($(this.option('modalPlayerContainerSelector'), modalNode));
            },

            /**
             * Creates a player
             * @param jQuery modalPlayerContainer
             * @private
             */
            _createVideoPlayer: function (modalPlayerContainer) {
                let url = modalPlayerContainer.data('giata-video-src') + '&autoplay=true';

                // Create player node
                let player = $('<iframe style="width:100%;height:100%;border:none;"></iframe>');
                player.attr('src', url);

                // Add CSS Class
                player.addClass(this.option('playerClass'));

                // Add to DOM
                modalPlayerContainer.empty();
                modalPlayerContainer.append(player);
            }
        });

        return GiataVideoModal;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/giatavideomodal/giataVideoModal.js